import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/41/thumb-landscape.jpg"

const Post41 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">HERMES／ピコタンPM／18 x18 x13cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>HERMES（エルメス）と言えば、誰もが「バーキン」「ケリー」といったバッグを最初に思い浮かべるのではないでしょうか？<br></br>しかし「バーキン」「ケリー」はなかなか実際に手にすることも難しく、日常使いも難しそうですよね。<br></br>そこで、近年HERMES（エルメス）をもっと日常に取り入れやすいと話題の、カジュアルな大人女子に人気のピコタン(Picotin)と言うバッグをご存知でしょうか？<br></br>今回は、ピコタンの人気の秘密と「ピコタン」「ピコタン・ロック」のサイズ展開、おすすめカラーなどを紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>①ピコタンとは</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>②ピコタンとピコタンロックの違い</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>③サイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>④人気カラー、サイズは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>⑤ピコタンの素材</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>⑥おすすめコーディネート</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>⑦まとめ</ScrollLink>          
        </p>
      </div>         
      <div name="sec1" className="text-two-cloumn">
        <h2>①ピコタン(Picotin)とは？</h2>
        <p>
          馬具を製造していたエルメス(HERMES)らしいアイテムで、元々は馬のエサを入れるためのバッグだったというエルメス(HERMES)のピコタン(Picotin)。そのため手頃な大きさで物を出し入れしやすい形になっています。
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/41/1.jpg" alt="大人カジュアルの永遠の憧れ。HERMES（エルメス）ピコタン(Picotin)とは？"/>
        <span className="text-center">
          左から<br></br>
          HERMES／ピコタンPM／18 x18 x13cm<br></br>
          HERMES／ピコタンロックGM／25 x25 x20cm
        </span>
      </figure>          
      <div name="sec2" className="text-max-width">
        <h2>②ピコタン(Picotin)と、ピコタンロック(Picotin Lock)の違い</h2>       
        <p>ピコタン(Picotin)は、2003年に発表された長いエルメス(HERMES)の歴史の中で、比較的新しいバッグです。（※写真下はピコタン）
        </p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/2.png" alt=""/>
        <span className="text-center">HERMES／ピコタンPM／18 x18 x13cm</span>
      </figure>
      <p className="text-max-width">
        「ピコタン」と「ピコタン・ロック」の違いですが、ロックと名がついている通り
        「ピコタン・ロック」には、鍵とカデナ（南京錠）がついておりバッグ自体に鍵が取り付けれる構造となっています。（※写真下はピコタン・ロック）
      </p> 
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/3.jpg" alt=""/>
        <span className="text-center">HERMES／ピコタンロックPM／18 x18 x13cm</span>
      </figure>
      <p className="text-max-width">
        ピコタンロックはピコタンの進化版として2008年に発売されました。発売から10年以上経った今も根強い人気です。シンプルなピコタンに開口部分を押さえるベルトとベルトを留めるカデナが付けられ、生産をストップしたピコタンに変わり現在はピコタンロックが主流となっています。
      </p>
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
       HERMESのバッグを見る
      </Link>           
      <div name="sec3" className="text-two-cloumn">
        <h2>③サイズ展開</h2>
        <p>
          ピコタンには３つのサイズ展開、ピコタンロックには5つのサイズ展開があります。<br></br>※現在ラクサスでのお取扱いサイズは（GM、MM、PM）3サイズです。
        </p>
      </div>
      <div className="text-max-width">
        <h2>■ピコタンロックGM /25x25x20cm(幅x高さxマチ)</h2>
        <p>しっかり荷物が収容できるサイズGMは、メンズの方にも人気のようです。シンプルで機能的。さすがエルメスのアイテムですね。ちなみに、サイズ表記はフランス語です。GMの意味は、Grand Modèle（グランモデル）＝大きいモデルという意味です。※ピコタンロックのみ、さらに大きいTGM　Très Grand Modèle（トレグランモデル）があります。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/4.jpg" alt=""/>
      </figure>                      
      <div className="text-max-width">
        <h2>■ピコタンロックMM /22x22x17cm(幅x高さxマチ)</h2>
        <p>GMより少し小さい、MMは長財布も入り日常使いしやすいサイズ。カラーによって、印象も全く変わるので幅広いシーンで使えそう。MMはMoyen Modèle（モワヤンモデル）のミディアムモデルという意味です。</p>
      </div>       
      <figure>
        <StaticImage src="../../images/posts/41/5.jpg" alt=""/>
      </figure>
      <div className="text-max-width">
        <h2>■ピコタンロックPM /18x18x13cm(幅x高さxマチ)</h2>
        <p>ピコタンの中でいちばん小さいサイズのPMサイズは、使い勝手の良いかわいらしいサイズ感。PMはPetit Modèle（プチモデル）という意味。ピコタンロックにはさらに小さいミクロというサイズがあります。こちらは本当に手のひらサイズ！（残念ながら現在ラクサスでのお取り扱いはありません。）<br></br>※写真下はピコタンPM</p>
      </div>               
      <figure>
        <StaticImage src="../../images/posts/41/6.jpg" alt=""/>
      </figure>
      <div name="sec4" className="text-two-cloumn">
        <h2>④人気カラー、サイズは？</h2>
        <p>
          人気サイズは、圧倒的にMMです！サイズ感が程よく使いやすいようですね♪
        </p>
      </div>
      <div className="text-max-width">
        <h2>■定番人気カラー「エトゥープ」</h2><p>MMサイズは「エトゥープ」というベージュカラーが定番人気です。 </p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/7.png" alt=""/>
      </figure> 
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
       HERMESのバッグを見る
      </Link>      
      <div name="sec5" className="text-two-cloumn">
        <h2>⑤ピコタンの素材</h2>
        <p>ピコタンには、布素材とレザー素材のものがあります。</p>
      </div>
      <div className="text-max-width">
        <h2>■布素材「トワルアッシュ」</h2>
        <p>エルメス（HERMES）が使用する布素材の中で、特に人気が高いのは「トワルアッシュ」です。カジュアルに気軽に持てるバッグということもあって、布素材も非常に人気です。しっかりとした布で、外傷にも強いのが特徴。2色の糸で織り上げてあり、折り目の均整が取れた美しさを強調しながら、さらに品位を上げています。</p></div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/9.png" alt=""/>
        <span className="text-center">HERMES／ピコタンPM／18 x18 x13cm</span>
      </figure>
      <div className="text-max-width">
        <h2>■レザー素材「トリヨンクレマンス」</h2>
        <p>現在ピコタンシリーズに使用している主な素材は「トリヨンクレマンス」です。シボ感のあるレザーは、傷が目立ちにくくカジュアルな装いにぴったりです。</p></div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/8.jpg" alt=""/>
        <span className="text-center">HERMES／ピコタンロックPM／18 x18 x13cm</span>
      </figure>
      <div name="sec6" className="text-two-cloumn">
        <h2>⑥おすすめコーディネート</h2>
        <p>休日カジュアルコーデには、カラーバッグがポイントに！大人カジュアルスタイルの完成。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/12.png" alt=""/>
        <span className="text-center">HERMES／ピコタンロックPM／18 x18 x13cm</span>
      </figure>
      <p className="text-max-width">
        定番カラーは、カラーニットとの相性◎今季復活のロングブーツとのコーデもかわいい♪
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/41/11.png" alt=""/>
        <span className="text-center">HERMES／ピコタンロックGM／25 x25 x20cm</span>
      </figure>                                              
      <div name="sec7" className="text-two-cloumn">
        <h2>⑦まとめ</h2>
        <p>
          いかがでしたでしょうか？<br></br>大人カジュアルの憧れバッグピコタンシリーズは、豊富なカラー展開と抜群の収納力の高さで人気のバッグです！一度、手に取ってみるとその魅力にハマってしまいそう。自分らしいカラーを選んでみてくださいね。
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
       HERMESのバッグを見る
      </Link>
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post41

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 41}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
